<template>
    <div>
       <v-card>
           <v-card-title class="subtitle-1 mt-2">{{$t('labels.CLI_SubjectProperty')}}</v-card-title>
           <v-card-text>
               <v-row col="12">
                   <v-col lg="3" sm="6" md="3">
                       <v-row no-gutters><span class="font-weight-black">{{$t('labels.CLI_UnitNumber')}}</span></v-row>
                       <v-row no-gutters><span>{{propertyDetail.UnitNumber}}</span></v-row>
                   </v-col>
                    <v-col lg="3" sm="6" md="3">
                       <v-row no-gutters><span class="font-weight-black">{{$t('labels.CLI_AddressLine1')}}</span></v-row>
                       <v-row no-gutters class="mt-2"><span>{{propertyDetail.AddressLine1}}</span> </v-row>
                   </v-col>
                    <!-- <v-col lg="3" sm="6" md="3">
                       <v-row no-gutters><span class="font-weight-black">{{$t('labels.CLI_AddressLine2')}}</span></v-row>
                       <v-row no-gutters class="mt-2"><span>{{propertyDetail.AddressLine2}}</span> </v-row>
                   </v-col> -->
                    <v-col lg="3" sm="6" md="3">
                       <v-row no-gutters><span class="font-weight-black">{{$t('labels.City')}}</span></v-row>
                       <v-row no-gutters class="mt-2"><span>{{propertyDetail.City}}</span> </v-row>
                   </v-col>
               </v-row>
                <v-row col="12">
                   <v-col lg="3" sm="6" md="3">
                       <v-row no-gutters><span class="font-weight-black">{{$t('labels.CLI_Province')}}</span></v-row>
                       <v-row no-gutters><span>{{propertyDetail.ProvinceDisplayName}}</span></v-row>
                   </v-col>
                    <v-col lg="3" sm="6" md="3">
                       <v-row no-gutters><span class="font-weight-black">{{$t('labels.CLI_Country')}}</span></v-row>
                       <v-row no-gutters class="mt-2"><span>{{propertyDetail.CountryDisplayName}}</span> </v-row>
                   </v-col>
                    <v-col lg="3" sm="6" md="3">
                       <v-row no-gutters><span class="font-weight-black">{{$t('labels.CLI_PostalCode')}}</span></v-row>
                       <v-row no-gutters class="mt-2"><span>{{propertyDetail.PostalCode}}</span> </v-row>
                   </v-col>                  
               </v-row>
           </v-card-text>
       </v-card>
    </div>
</template>
<script>
export default {
     props:["propertyDetail"]
}
</script>
<style scoped>

</style>